import {
  getPendingDemoClaimResumePath,
  peekPendingAuthRedirect,
} from "@/utils/demoEntryAnalysisSession"

/** Location state + timing for the /auth/signin ↔ /auth/signup mirrored split animation. */
export type AuthSplitVariant = "signin" | "signup"

export type AuthSplitLocationState = {
  /**
   * Set by the in-card switch links. The outgoing page has already slid its
   * halves onto the crossing point, so the incoming page starts there rather
   * than at its own resting layout.
   */
  authSplitCrossed?: boolean
}

/**
 * One leg of the criss-cross: resting layout → crossing point, then crossing
 * point → resting layout on the new route. Must match the CSS transition
 * duration, since the route change is scheduled off this value.
 */
export const AUTH_SPLIT_LEG_MS = 260

export function authSplitPath(variant: AuthSplitVariant): string {
  const base = variant === "signup" ? "/auth/signup" : "/auth/signin"
  if (typeof window === "undefined") return base
  const redirect =
    new URLSearchParams(window.location.search).get("redirect_url") ||
    peekPendingAuthRedirect() ||
    getPendingDemoClaimResumePath()
  if (!redirect) return base
  return `${base}?redirect_url=${encodeURIComponent(redirect)}`
}

export function authSplitCrossState(): AuthSplitLocationState {
  return { authSplitCrossed: true }
}
